export const PARAMS_ACCESS_TOKEN = "accessToken"
export const PARAMS_CLIENT_ID = "clientId"
export const PARAMS_ENVIRONMENT = "environment"
export const PARAMS_TRANSFER_INTENT_REFERENCE = "transferIntentId"
export const PARAMS_TRANSFER_REFERENCE = "transferReference"
export const PARAMS_USER_ID = "userId"
export const PARAMS_WEB_VIEW = 'isWebview'